<template>
  <div class="onebox">
    <drag-modal :visible="$store.state.dislog.Fours" @cancel="reset" :title='"添加进度-" + litetit'
      :class='{ "editbox": Edit }' width='1053px'>
      <div class="navbox" v-if='Edit'>
        <Nscroll @getIndex='see' @delCopy='copydel' :openEdit='openEdit'></Nscroll>
        <div class="intopbtn" v-if='!isAllDis'>
          <!-- <a-popconfirm title="确认新增此进度吗?" ok-text="确定" cancel-text="取消" @confirm="copyNew">
            <a-button icon="plus" v-if='!openEdit'>新增本进度</a-button>
          </a-popconfirm> -->
          <a-popconfirm title="确认删除当前进度吗?" ok-text="确定" cancel-text="取消" @confirm="delStep" v-if="
            step != 181 && $store.state.DisForm.infoList &&
            $common.AccAUTH($store.state.cause.accuser.id, $store.getters.stepPower.del)
          ">
            <a-button type="danger" icon="delete" style="margin-left: 12px">删除</a-button>
          </a-popconfirm>
          <a-button icon="edit"
            v-if='$common.AccAUTH($store.state.cause.accuser.id, $store.getters.stepPower.edit) && $store.getters.publicPower'
            style="margin-left:10px;" @click='openEdit = !openEdit'>{{ openEdit ? "修改" : "取消修改" }}</a-button>
        </div>
      </div>
      <a-spin :spinning="loading">
        <a-form-model ref="forms" :model="form" :rules="openEdit ? {} : rules" :label-col="{ span: 10 }"
          :wrapper-col="{ span: 24 }" class="rform">
          <div class="ant-row ant-form-item" v-if='[40, 43, 112].indexOf(step) < 0'
            style="margin:0;padding-bottom:15px;">
            <div class="ant-col ant-col-14 ant-form-item-control-wrapper" style="width:80%;"
              v-if='!openEdit && form.add == 1'>
              <!-- <div class="ant-form-item-control">
                <a-button icon="profile" class="mr20" :type="form.type==2?'primary':''" :disabled='form.type==3'>原告上诉</a-button>
                <a-button icon="profile" class="mr20" :type="form.type==3?' ':''" :disabled='form.type==2'>被告上诉</a-button>
              </div> -->
              <div class="ant-form-item-control">
                <a-button icon="profile" class="mr20" :type="form.type == 2 ? 'primary' : ''" @click='setpType(2)'>原告{{
                  step == 90 ? "上诉" : "申请" }}</a-button>
                <a-button icon="profile" class="mr20" :type="form.type == 3 ? 'primary' : ''" @click='setpType(3)'>被告{{
                  step == 90 ? "上诉" : "申请" }}</a-button>
              </div>
            </div>
            <div class="ant-col ant-col-14 ant-form-item-control-wrapper" style="width:80%;" v-else>
              <a-button icon="profile" class="mr20" type='primary'>{{ form.type == 2 ? "原告申请" : "被告申请" }}</a-button>
            </div>
          </div>
          <!-- <a-form-model-item label="本金" :label-col="{ span: 3 }" :wrapper-col="{ span: 14 }" prop='capital'
            :rules="{ required: false, message: '请输入本金', trigger: 'blur' }" class="bjlabel"
            v-if='step != 90 && step != 112 && step != 117'>
            <div class="ninputs">{{ $store.state.cause.capital | showYuan }}</div>
          </a-form-model-item> -->
          <div class="dul nbg" v-if='(step == 90 || step == 112 || step == 117) && form.type == 3'>
            <a-row :gutter="20" type="flex">
              <a-col style="width:20%;">
                <a-form-model-item :label="step == 90 ? '上诉人' : '申请人'" prop="appellor"
                  :rules="{ required: true, message: step == 90 ? '请选择上诉人' : '请选择申请人', trigger: 'change' }">
                  <Selsee v-if="openEdit" :list="withList" :ids="form.appellor"></Selsee>
                  <a-select v-model="form.appellor" :placeholder="step == 90 ? '请选择上诉人' : '请选择申请人'" :disabled='openEdit' mode="multiple" show-search
                    :filter-option="filterOption" v-else>
                    <a-select-option v-for='(i) in withList' :key='i.id'>{{ i.title }}</a-select-option>
                  </a-select>
                </a-form-model-item>
              </a-col>
              <a-col style="width:20%;">
                <a-form-model-item :label="step == 90 ? '被上诉人' : '被申请人'" prop="appellee"
                  :rules="{ required: true, message: step == 90 ? '请选择被上诉人' : '请选择被申请人', trigger: 'change' }">
                  <Selsee v-if="openEdit" :list="withList" :ids="form.appellee"></Selsee>
                  <a-select v-model="form.appellee" :placeholder="step == 90 ? '请选择被上诉人' : '请选择被申请人'" :disabled='openEdit' mode="multiple" show-search
                    :filter-option="filterOption" v-else>
                    <a-select-option v-for='(i) in withList' :key='i.id'>{{ i.title }}</a-select-option>
                  </a-select>
                </a-form-model-item>
              </a-col>
              <a-col style="width:20%;">
                <a-form-model-item label="案号" prop="no" :rules="{ required: false, message: '请输入案号', trigger: 'blur' }"
                  labelAlign="left">
                  <a-input v-model="form.no" placeholder="请输入案号" :disabled='openEdit' />
                </a-form-model-item>
              </a-col>
              <a-col style="width:20%;">
                <a-form-model-item label="法院地区：" prop="court"
                  :rules="{ required: true, message: '请选择法院地区', trigger: 'change' }">
                  <a-cascader :options="options" placeholder="请选择法院地区" change-on-select
                    :field-names="{ label: 'full_name', value: 'id', children: 'more' }" v-model='form.court'
                    @change='seachCourtList(form.court); form.court_id = null' :disabled='openEdit' />
                </a-form-model-item>
              </a-col>
              <a-col style="width:20%;">
                <a-form-model-item label="管辖法院" prop="court_id"
                  :rules="{ required: true, message: '请选择管辖法院', trigger: 'change' }">
                  <a-select show-search v-model="form.court_id" placeholder="请选择管辖法院" :allowClear='true'
                    :default-active-first-option="false" :show-arrow="false" :filter-option="false"
                    :not-found-content="null" :disabled='openEdit'>
                    <a-select-option v-for="d in courtList" :key="d.id">
                      {{ d.title }}
                    </a-select-option>
                  </a-select>
                </a-form-model-item>
              </a-col>
            </a-row>
          </div>
          <!-- <div class="licter" v-if='!openEdit'>
            <label>补充材料:</label>
            <div class="rmain">
              <a href="javascript:void(0);" @click='sAdd(1)'>电子</a>
              <a href="javascript:void(0);" @click='sAdd(2)'>微信</a>
              <a href="javascript:void(0);" @click='sAdd(3)'>现场</a>
              <a href="javascript:void(0);" @click='sAdd(4)'>邮寄</a>
            </div>
          </div>
          <div class="ilikecon">
            <div class="ilikebox" v-for='(i, index) in form.supp' :key='index'>
              <div class="likebox" v-if='i.type == 1'>
                <div class="htit">补充材料：电子
                  <span @click='sdel(index)' v-if='!openEdit'>
                    <a-icon type="minus-circle" />
                  </span>
                </div>
                <a-row :gutter="24">
                  <a-col :span='8'>
                    <a-form-model-item label="平台名称" :prop="'supp.' + index + '.platform'"
                      :rules="{ required: true, message: '请输入平台名称', trigger: 'blur' }">
                      <a-input v-model="i.platform" :disabled='openEdit' />
                    </a-form-model-item>
                  </a-col>
                  <a-col :span='8'>
                    <a-form-model-item label="材料名称" :prop="'supp.' + index + '.filename'"
                      :rules="{ required: true, message: '请输入材料名称', trigger: 'blur' }">
                      <a-input v-model="i.filename" :disabled='openEdit' />
                    </a-form-model-item>
                  </a-col>
                  <a-col :span='8'>
                    <a-form-model-item label="补充时间" :prop="'supp.' + index + '.time'"
                      :rules="{ required: true, message: '请选择补充时间', trigger: 'change' }">
                      <a-date-picker v-model="i.time" placeholder="请选择" show-time type="date"
                        valueFormat="YYYY-MM-DD HH:mm:ss" format='YYYY-MM-DD' :disabled='openEdit'
                        style="width:100%;" />
                    </a-form-model-item>
                  </a-col>
                </a-row>
                <a-row>
                  <a-col :span='24'>
                    <a-form-model-item label="备注" :prop="'supp.' + index + '.comment'">
                      <a-input v-model="i.comment" :disabled='openEdit' type='textarea' />
                    </a-form-model-item>
                  </a-col>
                </a-row>
              </div>
              <div class="likebox" v-if='i.type == 2'>
                <div class="htit">补充材料：微信
                  <span @click='sdel(index)' v-if='!openEdit'>
                    <a-icon type="minus-circle" />
                  </span>
                </div>
                <a-row :gutter="24">
                  <a-col :span='8'>
                    <a-form-model-item label="对方微信号" :prop="'supp.' + index + '.wx'"
                      :rules="{ required: true, message: '请输入对方微信号', trigger: 'blur' }">
                      <a-input v-model="i.wx" :disabled='openEdit' />
                    </a-form-model-item>
                  </a-col>
                  <a-col :span='8'>
                    <a-form-model-item label="材料名称" :prop="'supp.' + index + '.filename'"
                      :rules="{ required: true, message: '请输入材料名称', trigger: 'blur' }">
                      <a-input v-model="i.filename" :disabled='openEdit' />
                    </a-form-model-item>
                  </a-col>
                  <a-col :span='8'>
                    <a-form-model-item label="补充时间" :prop="'supp.' + index + '.time'"
                      :rules="{ required: true, message: '请输入补充时间', trigger: 'change' }">
                      <a-date-picker v-model="i.time" placeholder="请选择" show-time type="date"
                        valueFormat="YYYY-MM-DD HH:mm:ss" format='YYYY-MM-DD' :disabled='openEdit'
                        style="width:100%;" />
                    </a-form-model-item>
                  </a-col>
                </a-row>
                <a-row>
                  <a-col :span='24'>
                    <a-form-model-item label="备注" :prop="'supp.' + index + '.comment'">
                      <a-input v-model="i.comment" :disabled='openEdit' type='textarea' />
                    </a-form-model-item>
                  </a-col>
                </a-row>
              </div>
              <div class="likebox" v-if='i.type == 3'>
                <div class="htit">
                  补充材料：现场
                  <span @click='sdel(index)' v-if='!openEdit'>
                    <a-icon type="minus-circle" />
                  </span>
                </div>
                <a-row :gutter="24">
                  <a-col :span='8'>
                    <a-form-model-item label="补充提交人" :prop="'supp.' + index + '.submiter'"
                      :rules="{ required: true, message: '请输入补充提交人', trigger: 'blur' }">
                      <a-input v-model="i.submiter" :disabled='openEdit' />
                    </a-form-model-item>
                  </a-col>

                  <a-col :span='8'>
                    <a-form-model-item label="材料名称" :prop="'supp.' + index + '.filename'"
                      :rules="{ required: true, message: '请输入材料名称', trigger: 'blur' }">
                      <a-input v-model="i.filename" :disabled='openEdit' />
                    </a-form-model-item>
                  </a-col>
                  <a-col :span='8'>
                    <a-form-model-item label="补充时间" :prop="'supp.' + index + '.time'"
                      :rules="{ required: true, message: '请输入补充时间', trigger: 'change' }">
                      <a-date-picker v-model="i.time" placeholder="请选择" show-time type="date"
                        valueFormat="YYYY-MM-DD HH:mm:ss" format='YYYY-MM-DD' :disabled='openEdit'
                        style="width:100%;" />
                    </a-form-model-item>
                  </a-col>
                </a-row>
                <a-row>
                  <a-col :span='24'>
                    <a-form-model-item label="备注" :prop="'supp.' + index + '.comment'">
                      <a-input v-model="i.comment" :disabled='openEdit' type='textarea' />
                    </a-form-model-item>
                  </a-col>
                </a-row>
              </div>
              <div class="likebox" v-if='i.type == 4'>
                <div class="htit">
                  补充材料：邮寄
                  <span @click='sdel(index)' v-if='!openEdit'>
                    <a-icon type="minus-circle" />
                  </span>
                </div>
                <a-row :gutter="24">
                  <a-col :span='8'>
                    <a-form-model-item label="单号" :prop="'supp.' + index + '.ship_no'"
                      :rules="{ required: true, message: '请输入单号', trigger: 'blur' }">
                      <a-input v-model="i.ship_no" :disabled='openEdit' />
                    </a-form-model-item>
                  </a-col>
                  <a-col :span='8'>
                    <a-form-model-item label="联系方式" :prop="'supp.' + index + '.tel'"
                      :rules="{ required: true, message: '请输入联系方式', trigger: 'blur' }">
                      <a-input v-model="i.tel" :disabled='openEdit' />
                    </a-form-model-item>
                  </a-col>
                  <a-col :span='8'>
                    <a-form-model-item label="材料名称" :prop="'supp.' + index + '.filename'"
                      :rules="{ required: true, message: '请输入材料名称', trigger: 'blur' }">
                      <a-input v-model="i.filename" :disabled='openEdit' />
                    </a-form-model-item>
                  </a-col>
                </a-row>
                <a-row :gutter="24">
                  <a-col :span='8'>
                    <a-form-model-item label="收件人" :prop="'supp.' + index + '.receive_name'"
                      :rules="{ required: true, message: '请输入收件人', trigger: 'blur' }">
                      <a-input v-model="i.receive_name" :disabled='openEdit' />
                    </a-form-model-item>
                  </a-col>
                  <a-col :span='8'>
                    <a-form-model-item label="寄出时间" :prop="'supp.' + index + '.ship_time'"
                      :rules="{ required: true, message: '请选择寄出时间', trigger: 'change' }">
                      <a-date-picker v-model="i.ship_time" placeholder="请选择" show-time type="date"
                        valueFormat="YYYY-MM-DD HH:mm:ss" format='YYYY-MM-DD HH:mm:ss' :disabled='openEdit'
                        style="width:100%;" />
                    </a-form-model-item>
                  </a-col>
                  <a-col :span='8'>
                    <a-form-model-item label="">
                      <label v-if='openEdit'>{{ i.gout == "a" ? "签收时间:" : (i.gout == "b" ? "拒收时间:" : "无") }}</label>
                      <a-radio-group v-model='i.gout' :disabled='openEdit' style="white-space:nowrap;" size='small'
                        v-else>
                        <a-radio-button :value="null"
                          style="width:64px;text-align:center;font-size:12px;">无</a-radio-button>
                        <a-radio-button :value="'a'"
                          style="width:68px;font-size:12px;text-align:center;">签收时间</a-radio-button>
                        <a-radio-button :value="'b'"
                          style="width:68px;font-size:12px;text-align:center;">拒收时间</a-radio-button>
                      </a-radio-group>
                      <a-date-picker v-model="i.receive_time" placeholder="请选择" show-time type="date"
                        valueFormat="YYYY-MM-DD HH:mm:ss" format='YYYY-MM-DD HH:mm:ss' v-if='i.gout == "a"'
                        :disabled='openEdit' style="width:100%;" />
                      <a-date-picker v-model="i.return_time" placeholder="请选择" show-time type="date"
                        valueFormat="YYYY-MM-DD HH:mm:ss" format='YYYY-MM-DD HH:mm:ss' :disabled='openEdit'
                        style="width:100%;" v-if='i.gout == "b"' />
                      <a-input disabled v-if='!i.gout' />
                    </a-form-model-item>
                  </a-col>
                </a-row>
                <a-row :gutter="24">
                  <a-col :span='12'>
                    <a-form-model-item label="收件地址" :prop="'supp.' + index + '.addr'"
                      :rules="{ required: true, message: '请输入收件地址', trigger: 'blur' }">
                      <a-input v-model="i.addr" :disabled='openEdit' />
                    </a-form-model-item>
                  </a-col>
                  <a-col :span='12'>
                    <a-form-model-item label="备注" :prop="'supp.' + index + '.comment'"
                      :rules="{ required: false, message: '请输入备注', trigger: 'blur' }">
                      <a-input v-model="i.comment" :disabled='openEdit' />
                    </a-form-model-item>
                  </a-col>
                </a-row>
              </div>
            </div>
          </div>

          <div class="licter" v-if='!openEdit'>
            <label>接收材料:</label>
            <div class="rmain">
              <a href="javascript:void(0);" @click='sAdd(1, 1)'>电子</a>
              <a href="javascript:void(0);" @click='sAdd(2, 1)'>微信</a>
              <a href="javascript:void(0);" @click='sAdd(3, 1)'>现场</a>
              <a href="javascript:void(0);" @click='sAdd(4, 1)'>邮寄</a>
            </div>
          </div>
          <div class="ilikecon">
            <div class="ilikebox" v-for='(i, index) in form.accept_file' :key='index'>
              <div class="likebox" v-if='i.type == 1'>
                <div class="htit">接收材料：电子
                  <span @click='supdel(index)' v-if='!openEdit'>
                    <a-icon type="minus-circle" />
                  </span>
                </div>
                <a-row :gutter="24">
                  <a-col :span='8'>
                    <a-form-model-item label="平台名称" :prop="'accept_file.' + index + '.platform'"
                      :rules="{ required: true, message: '请输入平台名称', trigger: 'blur' }">
                      <a-input v-model="i.platform" :disabled='openEdit' />
                    </a-form-model-item>
                  </a-col>
                  <a-col :span='8'>
                    <a-form-model-item label="材料名称" :prop="'accept_file.' + index + '.filename'"
                      :rules="{ required: true, message: '请输入材料名称', trigger: 'blur' }">
                      <a-input v-model="i.filename" :disabled='openEdit' />
                    </a-form-model-item>
                  </a-col>
                  <a-col :span='8'>
                    <a-form-model-item label="接收时间" :prop="'accept_file.' + index + '.time'"
                      :rules="{ required: true, message: '请选择接收时间', trigger: 'change' }">
                      <a-date-picker v-model="i.time" placeholder="请选择" show-time type="date"
                        valueFormat="YYYY-MM-DD HH:mm:ss" format='YYYY-MM-DD' :disabled='openEdit'
                        style="width:100%;" />
                    </a-form-model-item>
                  </a-col>
                </a-row>
                <a-row>
                  <a-col :span='24'>
                    <a-form-model-item label="备注" :prop="'accept_file.' + index + '.comment'">
                      <a-input v-model="i.comment" :disabled='openEdit' type='textarea' />
                    </a-form-model-item>
                  </a-col>
                </a-row>
              </div>
              <div class="likebox" v-if='i.type == 2'>
                <div class="htit">接收材料：微信
                  <span @click='supdel(index)' v-if='!openEdit'>
                    <a-icon type="minus-circle" />
                  </span>
                </div>
                <a-row :gutter="24">
                  <a-col :span='8'>
                    <a-form-model-item label="对方微信号" :prop="'accept_file.' + index + '.wx'"
                      :rules="{ required: true, message: '请输入对方微信号', trigger: 'blur' }">
                      <a-input v-model="i.wx" :disabled='openEdit' />
                    </a-form-model-item>
                  </a-col>
                  <a-col :span='8'>
                    <a-form-model-item label="材料名称" :prop="'accept_file.' + index + '.filename'"
                      :rules="{ required: true, message: '请输入材料名称', trigger: 'blur' }">
                      <a-input v-model="i.filename" :disabled='openEdit' />
                    </a-form-model-item>
                  </a-col>
                  <a-col :span='8'>
                    <a-form-model-item label="接收时间" :prop="'accept_file.' + index + '.time'"
                      :rules="{ required: true, message: '请输入接收时间', trigger: 'change' }">
                      <a-date-picker v-model="i.time" placeholder="请选择" show-time type="date"
                        valueFormat="YYYY-MM-DD HH:mm:ss" format='YYYY-MM-DD' :disabled='openEdit'
                        style="width:100%;" />
                    </a-form-model-item>
                  </a-col>
                </a-row>
                <a-row :gutter="24">
                  <a-col :span='24'>
                    <a-form-model-item label="备注" :prop="'accept_file.' + index + '.comment'">
                      <a-input v-model="i.comment" :disabled='openEdit' type='textarea' />
                    </a-form-model-item>
                  </a-col>
                </a-row>
              </div>
              <div class="likebox" v-if='i.type == 3'>
                <div class="htit">
                  接收材料：现场
                  <span @click='supdel(index)' v-if='!openEdit'>
                    <a-icon type="minus-circle" />
                  </span>
                </div>
                <a-row :gutter="24">
                  <a-col :span='8'>
                    <a-form-model-item label="接收人" :prop="'accept_file.' + index + '.submiter'"
                      :rules="{ required: true, message: '请输入接收人', trigger: 'blur' }">
                      <a-input v-model="i.submiter" :disabled='openEdit' />
                    </a-form-model-item>
                  </a-col>

                  <a-col :span='8'>
                    <a-form-model-item label="材料名称" :prop="'accept_file.' + index + '.filename'"
                      :rules="{ required: true, message: '请输入材料名称', trigger: 'blur' }">
                      <a-input v-model="i.filename" :disabled='openEdit' />
                    </a-form-model-item>
                  </a-col>
                  <a-col :span='8'>
                    <a-form-model-item label="接收时间" :prop="'accept_file.' + index + '.time'"
                      :rules="{ required: true, message: '请输入接收时间', trigger: 'change' }">
                      <a-date-picker v-model="i.time" placeholder="请选择" show-time type="date"
                        valueFormat="YYYY-MM-DD HH:mm:ss" format='YYYY-MM-DD' :disabled='openEdit'
                        style="width:100%;" />
                    </a-form-model-item>
                  </a-col>
                </a-row>
                <a-row :gutter="24">
                  <a-col :span='24'>
                    <a-form-model-item label="备注" :prop="'accept_file.' + index + '.comment'">
                      <a-input v-model="i.comment" :disabled='openEdit' type='textarea' />
                    </a-form-model-item>
                  </a-col>
                </a-row>
              </div>
              <div class="likebox" v-if='i.type == 4'>
                <div class="htit">
                  接收材料：邮寄
                  <span @click='supdel(index)' v-if='!openEdit'>
                    <a-icon type="minus-circle" />
                  </span>
                </div>
                <a-row :gutter="24">
                  <a-col :span='8'>
                    <a-form-model-item label="单号" :prop="'accept_file.' + index + '.ship_no'"
                      :rules="{ required: true, message: '请输入单号', trigger: 'blur' }">
                      <a-input v-model="i.ship_no" :disabled='openEdit' />
                    </a-form-model-item>
                  </a-col>
                  <a-col :span='8'>
                    <a-form-model-item label="联系方式" :prop="'accept_file.' + index + '.tel'"
                      :rules="{ required: true, message: '请输入联系方式', trigger: 'blur' }">
                      <a-input v-model="i.tel" :disabled='openEdit' />
                    </a-form-model-item>
                  </a-col>
                  <a-col :span='8'>
                    <a-form-model-item label="材料名称" :prop="'accept_file.' + index + '.filename'"
                      :rules="{ required: true, message: '请输入材料名称', trigger: 'blur' }">
                      <a-input v-model="i.filename" :disabled='openEdit' />
                    </a-form-model-item>
                  </a-col>
                </a-row>
                <a-row :gutter="24">
                  <a-col :span='8'>
                    <a-form-model-item label="接收人" :prop="'accept_file.' + index + '.receive_name'"
                      :rules="{ required: true, message: '请输入接收人', trigger: 'blur' }">
                      <a-input v-model="i.receive_name" :disabled='openEdit' />
                    </a-form-model-item>
                  </a-col>
                  <a-col :span='8'>
                    <a-form-model-item label="寄出时间" :prop="'accept_file.' + index + '.ship_time'"
                      :rules="{ required: true, message: '请选择寄出时间', trigger: 'change' }">
                      <a-date-picker v-model="i.ship_time" placeholder="请选择" show-time type="date"
                        valueFormat="YYYY-MM-DD HH:mm:ss" format='YYYY-MM-DD HH:mm:ss' :disabled='openEdit'
                        style="width:100%;" />
                    </a-form-model-item>
                  </a-col>
                  <a-col :span='8'>
                    <a-form-model-item label="">
                      <label v-if='openEdit'>{{ i.gout == "a" ? "签收时间:" : (i.gout == "b" ? "拒收时间:" : "无") }}</label>
                      <a-radio-group v-model='i.gout' :disabled='openEdit' size='small' style="white-space:nowrap;"
                        v-else>
                        <a-radio-button :value="null"
                          style="width:64px;text-align:center;font-size:12px;">无</a-radio-button>
                        <a-radio-button :value="'a'"
                          style="width:68px;font-size:12px;text-align:center;">签收时间</a-radio-button>
                        <a-radio-button :value="'b'"
                          style="width:68px;font-size:12px;text-align:center;">拒收时间</a-radio-button>
                      </a-radio-group>
                      <a-date-picker v-model="i.receive_time" placeholder="请选择" show-time type="date"
                        valueFormat="YYYY-MM-DD HH:mm:ss" format='YYYY-MM-DD HH:mm:ss' v-if='i.gout == "a"'
                        :disabled='openEdit' style="width:100%;" />
                      <a-date-picker v-model="i.return_time" placeholder="请选择" show-time type="date"
                        valueFormat="YYYY-MM-DD HH:mm:ss" format='YYYY-MM-DD HH:mm:ss' :disabled='openEdit'
                        style="width:100%;" v-if='i.gout == "b"' />
                      <a-input disabled v-if='!i.gout' />
                    </a-form-model-item>
                  </a-col>
                </a-row>
                <a-row :gutter="24">
                  <a-col :span='12'>
                    <a-form-model-item label="收件地址" :prop="'accept_file.' + index + '.addr'"
                      :rules="{ required: true, message: '请输入收件地址', trigger: 'blur' }">
                      <a-input v-model="i.addr" :disabled='openEdit' />
                    </a-form-model-item>
                  </a-col>
                  <a-col :span='12'>
                    <a-form-model-item label="备注" :prop="'accept_file.' + index + '.comment'">
                      <a-input v-model="i.comment" :disabled='openEdit' />
                    </a-form-model-item>
                  </a-col>
                </a-row>
              </div>
            </div>
          </div> -->
          <!-- <div class="ant-row ant-form-item" v-if='!openEdit'>
            <div class="ant-col ant-col-1 ant-form-item-label" style="width:126px;text-align:left;"><label
                title="诉讼相关费用">诉讼相关费用</label></div>
            <div class="ant-col ant-col-14 ant-form-item-control-wrapper" style="width:80%;">
              <div class="ant-form-item-control">
                <a-button icon="plus" class="mr20" @click='plusAdd(1)'>诉讼费</a-button>
                <a-button icon="plus" class="mr20" @click='plusAdd(10)' v-if='step != 43'>上诉费</a-button>
                <a-button icon="plus" class="mr20" @click='plusAdd(2)'>公告费</a-button>
                <a-button icon="plus" class="mr20" @click='plusAdd(3)'>保全费</a-button>
                <a-button icon="plus" class="mr20" @click='plusAdd(4)'>律师费</a-button>
                <a-button icon="plus" class="mr20" @click='plusAdd(5)'>差旅费</a-button>
                <a-button icon="plus" @click='plusAdd(7)'>其他</a-button>
              </div>
            </div>
          </div> -->
          <div class="fourlist">
            <!-- <div class="dul">
              <div v-for='(i, index) in form.fee' :key='index' class="dil">
                <div class="li" v-if='i.type == 1'>
                  <div class="input">
                    <a-form-model-item label='诉讼费' :label-col="{ span: 9 }" :wrapper-col="{ span: 14 }"
                      :prop="'fee.' + index + '.fee'" :rules="[{ required: true, message: '请输入费用', trigger: 'blur' }, {
                        validator: Validator.priceVal, trigger: 'blur'
                      }]">
                      <a-input-number v-model="i.fee" style="width:140px;" placeholder='请输入' :precision="2" :min="0"
                        @input="handlePrice" :disabled='openEdit || i.audit' :class='{ "yellow": i.audit }' />
                    </a-form-model-item>
                  </div>
                  <div class="input">
                    <a-form-model-item label="缴费类型" :label-col="{ span: 9 }" :wrapper-col="{ span: 14 }"
                      :prop="'fee.' + index + '.give_way'"
                      :rules="{ required: true, message: '请选择缴费方式', trigger: 'change' }">
                      <a-select v-model="i.give_way" placeholder="请选择缴费类型" :disabled='openEdit'>
                        <a-select-option :value="1">全缴</a-select-option>
                        <a-select-option :value="2">半缴</a-select-option>
                        <a-select-option :value="3">补缴</a-select-option>
                      </a-select>
                    </a-form-model-item>
                  </div>
                  <div class="input">
                    <a-form-model-item label="支付方式" :label-col="{ span: 9 }" :wrapper-col="{ span: 14 }"
                      :prop="'fee.' + index + '.pay_way'"
                      :rules="{ required: true, message: '请输入支付方式', trigger: 'blur' }">
                      <a-input v-model="i.pay_way" placeholder="请输入支付方式" style="width:140px;" :disabled='openEdit' />
                    </a-form-model-item>
                  </div>
                  <div class="input">
                    <a-form-model-item label="时间" :label-col="{ span: 9 }" :wrapper-col="{ span: 14 }"
                      :prop="'fee.' + index + '.time'" :rules="{ required: true, message: '请选择时间', trigger: 'change' }">
                      <a-date-picker v-model="i.time" placeholder="请选择" show-time type="date"
                        valueFormat="YYYY-MM-DD HH:mm:ss" format='YYYY-MM-DD' :disabled='openEdit' />
                    </a-form-model-item>
                  </div>

                  <div class="btns" v-if='!openEdit && !i.audit'>
                    <a-icon type="minus-circle" class="i del" @click='del(index)' />
                  </div>
                </div>
                <div class="li" v-if='i.type == 10'>
                  <div class="input">
                    <a-form-model-item label='上诉费' :label-col="{ span: 9 }" :wrapper-col="{ span: 14 }"
                      :prop="'fee.' + index + '.fee'" :rules="[{ required: true, message: '请输入费用', trigger: 'blur' }, {
                        validator: Validator.priceVal, trigger: 'blur'
                      }]">
                      <a-input-number v-model="i.fee" style="width:140px;" placeholder='请输入' :precision="2" :min="0"
                        @input="handlePrice" :disabled='openEdit || i.audit' :class='{ "yellow": i.audit }' />
                    </a-form-model-item>
                  </div>
                  <div class="input">
                    <a-form-model-item label="缴费类型" :label-col="{ span: 9 }" :wrapper-col="{ span: 14 }"
                      :prop="'fee.' + index + '.give_way'"
                      :rules="{ required: true, message: '请选择缴费方式', trigger: 'change' }">
                      <a-select v-model="i.give_way" placeholder="请选择缴费类型" :disabled='openEdit'>
                        <a-select-option :value="1">全缴</a-select-option>
                        <a-select-option :value="2">半缴</a-select-option>
                        <a-select-option :value="3">补缴</a-select-option>
                      </a-select>
                    </a-form-model-item>
                  </div>
                  <div class="input">
                    <a-form-model-item label="支付方式" :label-col="{ span: 9 }" :wrapper-col="{ span: 14 }"
                      :prop="'fee.' + index + '.pay_way'"
                      :rules="{ required: true, message: '请输入支付方式', trigger: 'blur' }">
                      <a-input v-model="i.pay_way" placeholder="请输入支付方式" style="width:140px;" :disabled='openEdit' />
                    </a-form-model-item>
                  </div>
                  <div class="input">
                    <a-form-model-item label="时间" :label-col="{ span: 9 }" :wrapper-col="{ span: 14 }"
                      :prop="'fee.' + index + '.time'" :rules="{ required: true, message: '请选择时间', trigger: 'change' }">
                      <a-date-picker v-model="i.time" placeholder="请选择" show-time type="date"
                        valueFormat="YYYY-MM-DD HH:mm:ss" format='YYYY-MM-DD' :disabled='openEdit' />
                    </a-form-model-item>
                  </div>

                  <div class="btns" v-if='!openEdit && !i.audit'>
                    <a-icon type="minus-circle" class="i del" @click='del(index)' />
                  </div>
                </div>
                <div class="li" v-if='i.type == 2'>
                  <div class="input">
                    <a-form-model-item label="公告费" :label-col="{ span: 9 }" :wrapper-col="{ span: 14 }"
                      :prop="'fee.' + index + '.fee'" :rules="[{ required: true, message: '请输入费用', trigger: 'blur' }, {
                        validator: Validator.priceVal, trigger: 'blur'
                      }]">
                      <a-input-number v-model="i.fee" style="width:140px;" placeholder='请输入公告费' :precision="2" :min="0"
                        @input="handlePrice" :disabled='openEdit || i.audit' :class='{ "yellow": i.audit }' />
                    </a-form-model-item>
                  </div>
                  <div class="input">
                    <a-form-model-item label="公告费类型" :label-col="{ span: 9 }" :wrapper-col="{ span: 14 }"
                      :prop="'fee.' + index + '.notice_fee_way'"
                      :rules="{ required: true, message: '请选择公告费类型', trigger: 'change' }">
                      <a-select v-model="i.notice_fee_way" placeholder="请选择公告费类型" :disabled='openEdit'>
                        <a-select-option :value="1" v-if='step == 40 || step == 43'>开庭公告</a-select-option>
                        <a-select-option :value="2" v-if='step == 40 || step == 43'>判决公告</a-select-option>
                        <a-select-option :value="3" v-if='step == 90'>开庭公告</a-select-option>
                        <a-select-option :value="4" v-if='step == 90'>判决公告</a-select-option>
                        <a-select-option :value="5" v-if='step == 112'>开庭公告 </a-select-option>
                        <a-select-option :value="6" v-if='step == 112'>判决公告</a-select-option>
                        <a-select-option :value="7" v-if='step == 117'>开庭公告 </a-select-option>
                        <a-select-option :value="8" v-if='step == 117'>判决公告</a-select-option>
                      </a-select>
                    </a-form-model-item>
                  </div>
                  <div class="input">
                    <a-form-model-item label="支付方式" :label-col="{ span: 9 }" :wrapper-col="{ span: 14 }"
                      :prop="'fee.' + index + '.pay_way'"
                      :rules="{ required: true, message: '请输入支付方式', trigger: 'blur' }">
                      <a-input v-model="i.pay_way" placeholder="请输入支付方式" style="width:140px;" :disabled='openEdit' />
                    </a-form-model-item>
                  </div>
                  <div class="input">
                    <a-form-model-item label="时间" :label-col="{ span: 9 }" :wrapper-col="{ span: 14 }"
                      :prop="'fee.' + index + '.time'" :rules="{ required: true, message: '请选择时间', trigger: 'change' }">
                      <a-date-picker v-model="i.time" placeholder="请选择" show-time type="date"
                        valueFormat="YYYY-MM-DD HH:mm:ss" format='YYYY-MM-DD' :disabled='openEdit' />
                    </a-form-model-item>
                  </div>
                  <div class="btns" v-if='!openEdit && !i.audit'>
                    <a-icon type="minus-circle" class="i del" @click='del(index)' />
                  </div>
                </div>
                <div class="li" v-if='i.type == 3'>
                  <div class="input">
                    <a-form-model-item label="保全费" :label-col="{ span: 9 }" :wrapper-col="{ span: 14 }"
                      :prop="'fee.' + index + '.fee'" :rules="[{ required: true, message: '请输入费用', trigger: 'blur' }, {
                        validator: Validator.priceVal, trigger: 'blur'
                      }]">
                      <a-input-number v-model="i.fee" style="width:140px;" placeholder='请输入保全费' :precision="2" :min="0"
                        @input="handlePrice" :disabled='openEdit || i.audit' :class='{ "yellow": i.audit }' />
                    </a-form-model-item>
                  </div>
                  <div class="input">
                    <a-form-model-item label="类别" :label-col="{ span: 9 }" :wrapper-col="{ span: 14 }"
                      :prop="'fee.' + index + '.other_type'"
                      :rules="{ required: true, message: '请输入类别', trigger: 'blur' }">
                      <a-input v-model="i.other_type" placeholder="请输入类别" style="width:140px;" :disabled='openEdit' />
                    </a-form-model-item>
                  </div>
                  <div class="input">
                    <a-form-model-item label="支付方式" :label-col="{ span: 9 }" :wrapper-col="{ span: 14 }"
                      :prop="'fee.' + index + '.pay_way'"
                      :rules="{ required: true, message: '请输入支付方式', trigger: 'blur' }">
                      <a-input v-model="i.pay_way" placeholder="请输入支付方式" style="width:140px;" :disabled='openEdit' />
                    </a-form-model-item>
                  </div>
                  <div class="input">
                    <a-form-model-item label="时间" :label-col="{ span: 9 }" :wrapper-col="{ span: 14 }"
                      :prop="'fee.' + index + '.time'" :rules="{ required: true, message: '请选择时间', trigger: 'change' }">
                      <a-date-picker v-model="i.time" placeholder="请选择" show-time type="date"
                        valueFormat="YYYY-MM-DD HH:mm:ss" format='YYYY-MM-DD' :disabled='openEdit' />
                    </a-form-model-item>
                  </div>

                  <div class="btns" v-if='!openEdit && !i.audit'>
                    <a-icon type="minus-circle" class="i del" @click='del(index)' />
                  </div>
                </div>
                <div class="li" v-if='i.type == 4'>
                  <div class="input">
                    <a-form-model-item label="律师费" :label-col="{ span: 9 }" :wrapper-col="{ span: 14 }"
                      :prop="'fee.' + index + '.fee'" :rules="[{ required: true, message: '请输入费用', trigger: 'blur' }, {
                        validator: Validator.priceVal, trigger: 'blur'
                      }]">
                      <a-input-number v-model="i.fee" style="width:140px;" placeholder='请输入律师费' :precision="2" :min="0"
                        @input="handlePrice" :disabled='openEdit || i.audit' :class='{ "yellow": i.audit }' />
                    </a-form-model-item>
                  </div>
                  <div class="input">
                    <a-form-model-item label="类别" :label-col="{ span: 9 }" :wrapper-col="{ span: 14 }"
                      :prop="'fee.' + index + '.other_type'"
                      :rules="{ required: true, message: '请输入类别', trigger: 'blur' }">
                      <a-input v-model="i.other_type" placeholder="请输入类别" style="width:140px;" :disabled='openEdit' />
                    </a-form-model-item>
                  </div>
                  <div class="input">
                    <a-form-model-item label="支付方式" :label-col="{ span: 9 }" :wrapper-col="{ span: 14 }"
                      :prop="'fee.' + index + '.pay_way'"
                      :rules="{ required: true, message: '请输入支付方式', trigger: 'blur' }">
                      <a-input v-model="i.pay_way" placeholder="请输入支付方式" style="width:140px;" :disabled='openEdit' />
                    </a-form-model-item>
                  </div>
                  <div class="input">
                    <a-form-model-item label="时间" :label-col="{ span: 9 }" :wrapper-col="{ span: 14 }"
                      :prop="'fee.' + index + '.time'" :rules="{ required: true, message: '请选择时间', trigger: 'change' }">
                      <a-date-picker v-model="i.time" placeholder="请选择" show-time type="date"
                        valueFormat="YYYY-MM-DD HH:mm:ss" format='YYYY-MM-DD' :disabled='openEdit' />
                    </a-form-model-item>
                  </div>
                  <div class="btns" v-if='!openEdit && !i.audit'>
                    <a-icon type="minus-circle" class="i del" @click='del(index)' />
                  </div>
                </div>
                <div class="li" v-if='i.type == 5'>
                  <div class="input">
                    <a-form-model-item label="差旅费" :label-col="{ span: 9 }" :prop="'fee.' + index + '.fee'"
                      :wrapper-col="{ span: 14 }" :rules="[{ required: true, message: '请输入费用', trigger: 'blur' }, {
                        validator: Validator.priceVal, trigger: 'blur'
                      }]">
                      <a-input-number v-model="i.fee" style="width:140px;" placeholder='请输入差旅费' :precision="2" :min="0"
                        @input="handlePrice" :disabled='openEdit || i.audit' :class='{ "yellow": i.audit }' />
                    </a-form-model-item>
                  </div>
                  <div class="input">
                    <a-form-model-item label="类别" :label-col="{ span: 9 }" :prop="'fee.' + index + '.other_type'"
                      :wrapper-col="{ span: 14 }" :rules="{ required: true, message: '请输入类别', trigger: 'blur' }">
                      <a-input v-model="i.other_type" placeholder="请输入类别" style="width:140px;" :disabled='openEdit' />
                    </a-form-model-item>
                  </div>
                  <div class="input">
                    <a-form-model-item label="支付方式" :label-col="{ span: 9 }" :prop="'fee.' + index + '.pay_way'"
                      :wrapper-col="{ span: 14 }" :rules="{ required: true, message: '请输入支付方式', trigger: 'blur' }">
                      <a-input v-model="i.pay_way" placeholder="请输入支付方式" style="width:140px;" :disabled='openEdit' />
                    </a-form-model-item>
                  </div>
                  <div class="input">
                    <a-form-model-item label="时间" :label-col="{ span: 9 }" :prop="'fee.' + index + '.time'"
                      :wrapper-col="{ span: 14 }" :rules="{ required: true, message: '请选择时间', trigger: 'change' }">
                      <a-date-picker v-model="i.time" placeholder="请选择" show-time type="date"
                        valueFormat="YYYY-MM-DD HH:mm:ss" format='YYYY-MM-DD' :disabled='openEdit' />
                    </a-form-model-item>
                  </div>

                  <div class="btns" v-if='!openEdit && !i.audit'>
                    <a-icon type="minus-circle" class="i del" @click='del(index)' />
                  </div>
                </div>
                <div class="li" v-if='i.type == 6'>
                  <div class="input">
                    <a-form-model-item label="退费" :label-col="{ span: 9 }" :prop="'fee.' + index + '.fee'"
                      :wrapper-col="{ span: 14 }" :rules="[{ required: true, message: '请输入费用', trigger: 'blur' }, {
                        validator: Validator.priceVal, trigger: 'blur'
                      }]">
                      <a-input-number v-model="i.fee" style="width:140px;" placeholder='请输入退费' :precision="2" :min="0"
                        @input="handlePrice" :disabled='openEdit || i.audit' :class='{ "yellow": i.audit }' />
                    </a-form-model-item>
                  </div>
                  <div class="input">
                    <a-form-model-item label="类别" :label-col="{ span: 9 }" :prop="'fee.' + index + '.other_type'"
                      :wrapper-col="{ span: 14 }" :rules="{ required: true, message: '请输入类别', trigger: 'blur' }">
                      <a-input v-model="i.other_type" placeholder="请输入类别" style="width:140px;" :disabled='openEdit' />
                    </a-form-model-item>
                  </div>
                  <div class="input">
                    <a-form-model-item label="支付方式" :label-col="{ span: 9 }" :prop="'fee.' + index + '.pay_way'"
                      :wrapper-col="{ span: 14 }" :rules="{ required: true, message: '请输入支付方式', trigger: 'blur' }">
                      <a-input v-model="i.pay_way" placeholder="请输入支付方式" style="width:140px;" :disabled='openEdit' />
                    </a-form-model-item>
                  </div>
                  <div class="input">
                    <a-form-model-item label="时间" :label-col="{ span: 9 }" :prop="'fee.' + index + '.time'"
                      :wrapper-col="{ span: 14 }" :rules="{ required: true, message: '请选择时间', trigger: 'change' }">
                      <a-date-picker v-model="i.time" placeholder="请选择" show-time type="date"
                        valueFormat="YYYY-MM-DD HH:mm:ss" format='YYYY-MM-DD' :disabled='openEdit || i.audit' />
                    </a-form-model-item>
                  </div>
                  <div class="btns" v-if='!openEdit && !i.audit'>
                    <a-icon type="minus-circle" class="i del" @click='del(index)' />
                  </div>
                </div>
                <div class="li" v-if='i.type == 7'>
                  <div class="input">
                    <a-form-model-item label="其他" :label-col="{ span: 9 }" :prop="'fee.' + index + '.fee'"
                      :wrapper-col="{ span: 14 }" :rules="[{ required: true, message: '请输入费用', trigger: 'blur' }, {
                        validator: Validator.priceVal, trigger: 'blur'
                      }]">
                      <a-input-number v-model="i.fee" style="width:140px;" placeholder='请输入' :precision="2" :min="0"
                        @input="handlePrice" :disabled='openEdit || i.audit' :class='{ "yellow": i.audit }' />
                    </a-form-model-item>
                  </div>
                  <div class="input">
                    <a-form-model-item label="类别" :label-col="{ span: 9 }" :prop="'fee.' + index + '.other_type'"
                      :wrapper-col="{ span: 14 }" :rules="{ required: true, message: '请输入类别', trigger: 'blur' }">
                      <a-input v-model="i.other_type" placeholder="请输入类别" style="width:140px;" :disabled='openEdit' />
                    </a-form-model-item>
                  </div>
                  <div class="input">
                    <a-form-model-item label="支付方式" :label-col="{ span: 9 }" :prop="'fee.' + index + '.pay_way'"
                      :wrapper-col="{ span: 14 }" :rules="{ required: true, message: '请输入支付方式', trigger: 'blur' }">
                      <a-input v-model="i.pay_way" placeholder="请输入支付方式" style="width:140px;" :disabled='openEdit' />
                    </a-form-model-item>
                  </div>

                  <div class="input">
                    <a-form-model-item label="时间" :label-col="{ span: 9 }" :prop="'fee.' + index + '.time'"
                      :wrapper-col="{ span: 14 }" :rules="{ required: true, message: '请选择时间', trigger: 'change' }">
                      <a-date-picker v-model="i.time" placeholder="请选择" show-time type="date"
                        valueFormat="YYYY-MM-DD HH:mm:ss" format='YYYY-MM-DD' :disabled='openEdit' />
                    </a-form-model-item>
                  </div>
                  <div class="btns" v-if='!openEdit'>
                    <a-icon type="minus-circle" class="i del" @click='del(index)' />
                  </div>
                </div>
              </div>
            </div> -->
            <div class="htit">{{ toTypeName(step, '开庭') }}信息<a-button icon='plus' style="margin:-10px 0 0 10px;"
                @click='blaxShow = true' v-if='!openEdit'>添加</a-button>
            </div>
            <div class="blax" v-if='blaxShow && !openEdit' style="padding-top:20px;">
              <a-form-model ref="smforms" :model="open" :rules="smrules">
                <div class="dul ndul">
                  <div class="li">
                    <div class="input">
                      <a-form-model-item :label="toTypeName(step, '开庭') + '时间'" prop='time' :label-col="{ span: 24 }"
                        :rules="{ required: false, message: '请选择开庭时间', trigger: 'change' }">
                        <a-date-picker show-time v-model="open.time" type="date" placeholder="请选择开庭时间"
                          valueFormat="YYYY-MM-DD HH:mm:ss" format='YYYY-MM-DD HH:mm' style="width:100%;" />
                      </a-form-model-item>
                    </div>
                    <div class="input">
                      <a-form-model-item :label="toTypeName(step, '开庭') + '地点'" prop='addr'
                        :rules="{ required: false, message: '请输入开庭地点', trigger: 'blur' }" :label-col="{ span: 24 }">
                        <a-input v-model="open.addr" style="width:100%;" placeholder='请输入开庭地点' />
                      </a-form-model-item>
                    </div>
                    <div class="input">
                      <a-row style="display:flex;">
                        <a-col :span='11'>
                          <a-form-model-item :label="toTypeName(step, '庭审') + '方式'" prop='trial_way'
                            :rules="{ required: false, message: '请选择', trigger: 'change' }" :label-col="{ span: 24 }">
                            <a-select v-model="open.trial_way" placeholder="请选择" style="width:100%;">
                              <a-select-option :value="1">现场</a-select-option>
                              <a-select-option :value="2">线上</a-select-option>
                            </a-select>
                          </a-form-model-item>
                        </a-col>
                        <a-col :span='11' :offset="2">
                          <a-form-model-item :label="'是否已' + toTypeName(step, '开庭')" prop='is_open'
                            :label-col="{ span: 24 }" :rules="{ required: false, message: '请选择', trigger: 'change' }">
                            <a-select v-model="open.is_open" placeholder="请选择" style="width:100%;" @change="isopencg">
                              <a-select-option :value="0">否</a-select-option>
                              <a-select-option :value="1">是</a-select-option>
                            </a-select>
                          </a-form-model-item>
                        </a-col>
                      </a-row>
                    </div>

                  </div>
                  <div class="li">
                    <div class="input">
                      <a-col :span='11'>
                        <a-form-model-item :label="step == 43 ? '承办调解员' : '承办法官'" prop='judge' :label-col="{ span: 24 }"
                          :rules="{ required: false, message: step == 43 ? '承办调解员' : '承办法官', trigger: 'blur' }">
                          <a-input v-model="open.judge" style="width:100%;" :placeholder="step == 43 ? '请输入承办调解员' : '请输入承办法官'" />
                        </a-form-model-item>
                      </a-col>
                      <a-col :span='11' :offset='2'>
                        <a-form-model-item label="联系方式" prop='judge_tel' :label-col="{ span: 24 }"
                          :rules="{ required: false, message: '请输入联系方式', trigger: 'blur' }">
                          <a-input v-model="open.judge_tel" style="width:100%;" placeholder="请输入联系方式" />
                        </a-form-model-item>
                      </a-col>

                    </div>
                    <div class="input">
                      <a-col :span='11'>
                        <a-form-model-item label="书记员" prop='clerk' :label-col="{ span: 24 }"
                          :rules="{ required: false, message: '请输入书记员', trigger: 'blur' }">
                          <a-input v-model="open.clerk" style="width:100%;" placeholder="请输入书记员" />
                        </a-form-model-item>
                      </a-col>
                      <a-col :span='11' :offset='2'>
                        <a-form-model-item label="联系方式" prop='clerk_tel' :label-col="{ span: 24 }"
                          :rules="{ required: false, message: '请输入联系方式', trigger: 'blur' }">
                          <a-input v-model="open.clerk_tel" style="width:100%;" placeholder="请输入联系方式" />
                        </a-form-model-item>
                      </a-col>
                    </div>
                    <div class="input">

                      <a-col :span='24' v-if='open.is_open == 0'>
                        <a-form-model-item label="备注" prop='clerk' :label-col="{ span: 24 }"
                          :rules="{ required: false, message: '请输入备注', trigger: 'blur' }">
                          <a-input v-model="open.comment" placeholder="请输入备注" />
                        </a-form-model-item>
                      </a-col>
                    </div>
                  </div>
                  <a-button type="primary" style="margin:-10px 0 20px;" @click='saveOpen'>
                    {{ oform ? "确认修改" : "确认" }}
                  </a-button>
                  <a-button style="margin:-10px 0 0 10px;" v-if="oform" @click='canopen'>
                    取消修改
                  </a-button>
                </div>
              </a-form-model>
            </div>
            <div class="table">
              <table>
                <thead>
                  <td width='140'>{{ toTypeName(step, '开庭') }}时间</td>
                  <td>{{ toTypeName(step, '开庭') }}地点</td>
                  <td>{{ toTypeName(step, '庭审') }}方式</td>
                  <td width='20%'>{{ step == 43 ? '承办调解员' : '承办法官' }}及联系方式</td>
                  <td width='18%'>书记员及联系方式</td>
                  <td>是否已{{ toTypeName(step, '开庭') }}</td>
                  <td>备注</td>
                  <td width='10%'>操作</td>
                </thead>
                <tbody>
                  <tr v-for='(i, index) in form.open' :key='index'>
                    <td>
                      <span v-if='i.time'>{{ i.time.slice(0, 16) }}</span>
                      <span v-else>/</span>
                    </td>
                    <td>
                      <Normap :tit='i.addr'></Normap>
                    </td>
                    <td>{{ i.trial_way == 1 ? "现场" : "线上" }}</td>
                    <td>{{ i.judge }}-{{ i.judge_tel }}</td>
                    <td>{{ i.clerk }}-{{ i.clerk_tel }}</td>
                    <td>{{ i.is_open == 0 ? "否" : "是" }} </td>
                    <td>
                      <Normap :tit='i.comment'></Normap>
                    </td>
                    <td>
                      <div class="popconfirm" v-if='!openEdit' style="margin:0 auto;">
                        <a-popconfirm title="确认删除此条数据吗?" ok-text="确定" cancel-text="取消" @confirm='tabdel(index)'>
                          <a href="javascript:void(0);">删除</a>
                        </a-popconfirm>
                        <span class="line"></span>

                        <a href="javascript:void(0);" @click='editsm(i, index)'>修改</a>
                        <!-- <a-icon type="minus-circle" class="i del" @click='tabdel(index)' />
                        <a-icon type="edit" class="i edit" @click='editsm(i,index)' /> -->
                      </div>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
            <a-form-model-item :wrapper-col="{ span: 24 }" prop="files"
              :rules="{ required: false, message: '请上传附件', trigger: 'change' }" style="margin-top:20px;">
              <Upload @isDisabled="parentHandle" :fList='form.files' @upFileAfter='lisUpload' :edit='openEdit'
                v-if='!loading' />
            </a-form-model-item>
          </div>

          <a-form-model-item :wrapper-col="{ span: 24 }" v-if='!openEdit' style="text-align:center;">
            <a-popconfirm :disabled="disabledShow" title="确认提交此条数据吗?" ok-text="确定" cancel-text="取消" @confirm='confirm'>
              <a-button :disabled="disabledShow" type="primary" style="width:148px;">
                提交
              </a-button>
            </a-popconfirm>
            <a-button style=" margin-left: 20px;width:148px;background:#B2C9E1;color:#fff;" @click='reset'>取消</a-button>
          </a-form-model-item>
        </a-form-model>
      </a-spin>
    </drag-modal>
  </div>
</template>
<script>
import Nscroll from "@/components/nscroll"
import Upload from "@/components/uploads"
import { mapGetters, mapActions } from 'vuex'
import { dktAdd, dktEdit, dktDetails, with_debtor, delJd } from "@/server/speed"
import { toTypeName } from "@/assets/js/formData"
import city from "@/assets/js/city.json"
import { citySort } from '@/assets/js/unit'
import { getDirectory } from "@/server/directory"
import Selsee from '@/components/selsee'
import Validator from "@/assets/js/yz.js"
export default {
  name: "Four",
  computed: {
    ...mapGetters([
      'litetit',
      'Edit'
    ]),
    formKey() {
      const keyArr = ["type", "files", "fee", "open", "audit", "supp", "accept_file"];   // "capital", "capitalId"
      if (this.step == 90 || this.step == 112 || this.step == 117) {
        keyArr.push("appellor", "appellee", "no", "court", "add", "court_id")
      }
      return keyArr
    }
  },
  components: {
    Upload, Nscroll, Selsee
  },
  data() {
    return {
      Validator,
      options: citySort(city),
      blaxShow: false,
      isAllDis: this.$route.query.t,
      step: this.$store.state.StepLite * 1,
      withList: [],
      oform: false,
      ofIndex: 0,
      form: {
        type: null,
        court_id: null,
        //  capital: this.$store.state.cause.capital,
        open: [],
        fee: [],
        files: [],
        supp: [],
        accept_file: []
        // capitalId: null
      },
      courtList: [],
      capitalAudit: false,
      smrules: {},
      open: {
        time: null,
        addr: null,
        trial_way: 1, // 1：现场，2：线上
        judge: null,
        judge_tel: null,
        clerk: null,
        clerk_tel: null,
        is_open: 0,
        comment: null,
        id: 0
      },  //开庭信息
      rules: {},
      loading: true,
      openEdit: false,
      disabledShow: false
    }
  },
  created() {
    if (this.step == 90 || this.step == 112 || this.step == 117) {
      with_debtor({ id: this.$store.state.cause.id }).then(e => {
        this.withList = e.list
      })
    }
    this.form.type = this.formType()
    if (this.Edit) {
      this.$nextTick(() => {
        const feeKey = {
          10: ["fee", "give_way", "time", "pay_way", "id", "audit"],
          1: ["fee", "give_way", "time", "pay_way", "id", "audit"],
          2: ["fee", "notice_fee_way", "time", "pay_way", "id", "audit"],
          3: ["fee", "time", "pay_way", "id", "audit", "other_type"],
          4: ["fee", "time", "pay_way", "id", "audit", "other_type"],
          5: ["fee", "time", "id", "audit", "pay_way", "other_type"],
          6: ["fee", "time", "id", "audit", "pay_way", "other_type"],
          7: ["fee", "time", "id", "audit", "pay_way", "other_type"],
          8: ["fee", "time", "id"],
        }
        dktDetails({ cause_id: this.$store.state.cause.id, step: this.$store.state.StepLite }).then(e => {
          let newList = e.list;
          newList.map(ele => {
            if ((this.step == 90 || this.step == 112 || this.step == 117)) {
              if (ele.dkt.appellor * 1 == 0) {
                ele.dkt.appellor = [];
                ele.dkt.appellee = []
              } else {
                ele.dkt.appellor = ele.dkt.appellor.split(",")
                ele.dkt.appellee = ele.dkt.appellee.split(",")
              }
            }
            if (ele.dkt.court_id) {
              ele.dkt.court = ele.dkt.courte ? [ele.dkt.courte.province_id, ele.dkt.courte.city_id, ele.dkt.courte.area_id] : [110000]
              this.seachCourtList(ele.dkt.court)
            }
            ele.dkt.supp = Object.keys(ele.dkt.supp).map(key => ele.dkt.supp[key])
            ele.dkt.accept_file = Object.keys(ele.dkt.accept_file).map(key => ele.dkt.accept_file[key])

          })
          newList.map(ele => {
            let fee = []
            ele.dkt.fee.map(element => {
              element.fee = element.fee / 100
              element.audit = element.audit === null ? false : true;
              if (element.type != 8) {
                let item = { type: element.type }
                feeKey[element.type].map(s => {
                  item[s] = element[s]
                })

                fee.push(item)
              } else {
                this.capitalAudit = element.audit ? true : false
                // ele.dkt.capital = element.fee;
                // ele.dkt.capitalId = element.id
              }
            })
            ele.dkt.supp.map(element => {
              for (let val in element) {
                if (!element[val]) {
                  delete element[val]
                }
              }
              if (element.type * 1 == 4) {
                element.gout = (!element.receive_time && !element.return_time) ? null : (element.receive_time ? "a" : "b")
              }
            })
            ele.dkt.accept_file.map(element => {
              for (let val in element) {
                if (!element[val]) {
                  delete element[val]
                }
              }
              if (element.type * 1 == 4) {
                element.gout = (!element.receive_time && !element.return_time) ? null : (element.receive_time ? "a" : "b")
              }
            })
            ele.dkt.fee = fee
          })
          this.$store.dispatch("settime", e.list[0].dkt.update_time)
          this.Infokey({ key: 'infoList', value: newList })
          this.see(0)
        })
        this.openEdit = true;
      })
    } else {
      this.form.add = 1;
      this.loading = false;
    }
  },
  methods: {
    parentHandle(data) {
      this.disabledShow = data
    },
    handlePrice(value, index) {
      if (value < 0) {
        this.$set(this.fee[index], 'fee', '');
        return;
      }
      const formatted = Validator.formatAmount(value);
      this.$set(this.fee[index], 'fee', formatted ? Number(formatted) : '');
    },
    toTypeName,
    seachCourtList(val) {      //搜索法院
      let province_id = val[0],
        city_id = val.length > 1 ? val[1] : '',
        area_id = val.length > 2 ? val[2] : '';
      getDirectory({ province_id: province_id, city_id: city_id, area_id: area_id }).then(e => {
        this.courtList = e.list
      })
    },
    setpType(type) {
      this.form.type = type;
      // if (!this.form.court) {
      //   this.form.appellor = []
      //   this.form.appellee = []
      // }
    },
    editsm(item, index) {
      this.open = JSON.parse(JSON.stringify(item))
      this.ofIndex = index
      this.blaxShow = true;
      this.oform = true;
    },
    canopen() {
      this.oform = false;
      this.blaxShow = false;
      this.open = {}
    },
    isopencg(val) {
      if (val == 1) {
        this.open.comment = null
      }
    },
    filterOption(input, option) {
      return (
        option.componentOptions.children[0].text.toLowerCase().indexOf(input.toLowerCase()) >= 0
      );
    },
    formType() {
      if (this.$store.state.StepLite == 40) {
        return 1
      } else {
        // if (this.$store.state.nineBool) { //false被告    true 原告
        //   return 2
        // } else {
        //   return 3
        // }
        return 2
      }
    },
    saveOpen() {
      if(!this.open.time&&!this.open.addr&&!this.open.judge&&!this.open.judge_tel&&!this.open.clerk&&!this.open.clerk_tel)
       return this.$message.warning({ content: '无法提交空数据'});
          if (this.oform) {
            this.form.open[this.ofIndex] = JSON.parse(JSON.stringify(this.open))
            this.open.comment = null
            this.oform = false;
            this.$refs.smforms.resetFields()
            this.blaxShow = false;
          } else {
            let form = JSON.parse(JSON.stringify(this.open))
            if (form.id) {
              form.id = 0
            }
            this.form.open.push(form)
            this.open.comment = null
            this.$refs.smforms.resetFields()
          }
    },
    ...mapActions({
      Newdel: 'DisForm/copydel',
      seeInfo: 'DisForm/see',
      addNew: 'DisForm/addNew',
      Infokey: 'DisForm/setInfokey',
      reMove: 'DisForm/reMove'
    }),
    sAdd(type, lite) {
      let smForm = {
        type: type
      }
      if (type == 4) {
        smForm.gout = null
      }
      if (lite) {
        this.form.accept_file.push(smForm)
      } else {
        this.form.supp.push(smForm)
      }
    },
    plusAdd(type) {
      let smForm = {
        type: type,
        id: 0
      }
      this.form.fee.push(smForm)
    },
    delStep() {
      let curIndex = this.$store.state.DisForm.curIndex
      let step_id = this.$store.state.DisForm.infoList[curIndex].id
      delJd({ step_id: step_id }).then(e => {
        this.$message.success("已提交审核")
        setTimeout(e => {
          window.history.go(0)
        }, 500)
      })
    },
    async copydel(index) {        //删除进度
      await this.Newdel({ index: index, formKey: this.formKey, valkey: "dkt" }).then(e => {
        this.form = JSON.parse(JSON.stringify(e));
        this.loading = false;
      })
    },
    copyNew() {        //新增复制进度
      this.loading = true;
      let copyItem = {
        cause_id: null,
        id: null,

        dkt: {
          add: 1,
          supp: [],       //补充材料数组
          accept_file: [],
          type: this.formType(),
          //      capital: null,
          open: [],
          fee: [],
          files: []
        },
        title: this.litetit
      }
      this.capitalAudit = false;
      this.addNew(copyItem).then(index => {
        this.form = {
          type: this.formType(),
          supp: [],       //补充材料数组
          accept_file: [],
          //      capital: null,
          add: 1,    //判断新增的情况下 才可以 有切换
          open: [],
          fee: [],
          blaxShow: false,
          files: []
        }
        this.loading = false;
      })
    },
    async see(index) {        //查看切换 审批
      this.loading = true;
      this.seeInfo({ index: index, formKey: this.formKey, valkey: "dkt" }).then(e => {
        this.capitalAudit = e.audit ? true : false;
        this.form = JSON.parse(JSON.stringify(e));
        this.loading = false;
      })
    },
    confirm() {
      this.$refs.forms.validate(valid => {
        if (valid) {
          let form = JSON.parse(JSON.stringify(this.form));
          for (let val in form) {
            if (!form[val]) {
              delete form[val]
            }
            if (form.audit) {
              delete form.audit
            }
          }
          if ((this.step == 90 || this.step == 112 || this.step == 117) && form.type == 3) {
            form.appellor = form.appellor.join(",")
            form.appellee = form.appellee.join(",")
          }
          if ((this.step == 90 || this.step == 112 || this.step == 117) && form.type == 2) {
            if (form.no) {
              form.no = form.no.replace(/\s/g, '');
            }
            delete form.appellor
            delete form.appellee
            delete form.court
            delete form.court_id
            delete form.no
          }
          if (form.files && form.files.length > 0) {
            form.files = form.files.map(ele => {
              return ele.upload_id || ele
            })
          }
          form.supp.map(ele => {
            if (ele.type == 4) {
              if (ele.gout == "a") {
                delete ele.return_time
              } else if (ele.gout == "b") {
                delete ele.receive_time
              } else {
                delete ele.return_time
                delete ele.receive_time
              }
              delete ele.gout
            }
          })
          form.accept_file.map(ele => {
            if (ele.type == 4) {
              if (ele.gout == "a") {
                delete ele.return_time
              } else if (ele.gout == "b") {
                delete ele.receive_time
              } else {
                delete ele.return_time
                delete ele.receive_time
              }
              delete ele.gout
            }
          })
          form.fee.map(ele => {
            ele.fee = ele.fee * 100
          })
          if (form.add) {     //特殊新增 
            delete form.add
          }
          //  delete form.capital
          let curIndex = this.$store.state.DisForm.curIndex
          let isEditCopyAdd = this.$store.state.DisForm.copyIndex.indexOf(curIndex) >= 0 ? true : false   //当前是否是在修改下的新增
          form.step = this.step
          if (this.Edit && !isEditCopyAdd) {      //修改
            let id = this.$store.state.DisForm.infoList[curIndex].dkt.id
            form.id = id;
            dktEdit(form).then(e => {
              this.$message.success({ content: '修改成功', key: 'updatable' });
              this.$parent.$parent.init(this.$store.state.cause.id)
              this.$store.dispatch("Case/getlist", { debtor_id: this.$route.params.id })
              this.reset()
            })
          } else {
            form.cause_id = this.$store.state.cause.id
            dktAdd(form).then(e => {
              this.$message.success({ content: '新增成功', key: 'updatable' });
              this.$parent.$parent.init(this.$store.state.cause.id)
              this.$store.dispatch("Case/getlist", { debtor_id: this.$route.params.id })
              this.reset()
            })
          }
        } else {
          console.log('error submit!!');
          return false;
        }
      });
    },
    tabdel(index) {
      this.form.open.splice(index, 1)
    },
    del(index) {
      this.form["fee"].splice(index, 1)
    },
    sdel(index) {
      let supp = JSON.parse(JSON.stringify(this.form.supp))
      supp.splice(index, 1)
      this.form.supp = supp
    },
    supdel(index) {
      let supp = JSON.parse(JSON.stringify(this.form.accept_file))
      supp.splice(index, 1)
      this.form.accept_file = supp
    },
    reset() {
      this.reMove().then(e => {
        this.$refs.forms.resetFields();
        this.$store.dispatch('openkey', { key: 'Fours', by: false })
      })
    },
    lisUpload(fileList) {
      this.form.files = fileList
    },
  }
}
</script>
<style lang="less">
.fourlist .ant-calendar-picker {
  min-width: auto !important;
}

.bjlabel .ant-form-item-label {
  text-align: left;
  width: 80px;
}
</style>
<style lang="less" scoped>
.ilikecon {
  max-height: 400px;
  overflow: auto;
}

.likebox {
  padding: 20px;
  background: #f3f6fb;
  margin-bottom: 10px;
  border-radius: 8px;

  .ant-form-item {
    margin: 0 !important;
  }

  /deep/ .ant-form-item-label {
    text-align: left !important;
  }

  .htit {
    font-size: 1rem;
    color: #0e2949;
    line-height: 19px;
    margin-bottom: 12px;

    span {
      color: #f00;
      cursor: pointer;
    }
  }
}

.mr20 {
  margin-right: 20px;
}

.fourlist {
  overflow: auto;
  height: 500px;
  margin-bottom: 20px;

  & .dil:nth-child(1) {
    .li {
      padding-top: 1.25rem;
    }
  }
}

.htit {
  font-size: 1rem;
  color: #333;
  line-height: 40px;
  margin: 10px 0;
}

.dul {
  margin: 0 2px;

  .li {
    border-radius: 4px;

    background: #f3f6fb;
    display: flex;

    .input {
      width: 33.3%;
    }

    &:nth-last-child(1) {
      margin: 0;
    }
  }

  .dil {
    .li {
      .input {
        width: 25%;

        &:nth-last-child(1) {
          padding-right: 8px;
        }
      }
    }
  }
}

.nbg {
  .li {
    background: none;
  }
}

.blax {
  width: 100%;
  background: #f3f6fb;

  .dul {
    padding: 0 20px;
  }

  .li {
    display: flex;
    width: 100%;

    .input {
      flex: 1;
      max-width: 30%;
      padding-right: 20px;
    }

    // .input {
    //   max-width: 30%;
    // }
  }

  .ndul {
    .li {
      .input {
        flex: 1;
        max-width: 33.3%;

        &:nth-last-child(1) {
          padding-right: 0;
        }
      }
    }
  }
}

.table {
  table {
    width: 100%;
  }
}

.morebar {
  display: flex;
  margin-bottom: 10px;
  height: 40px;
  align-items: center;

  &:nth-last-child(1) {
    margin-bottom: 0;
  }
}

/deep/ .ant-form-item {
  margin-bottom: 12px;
}

.li .popconfirm {
  width: 5%;
  display: flex;
  font-size: 1.25rem;
  justify-content: space-between;
  padding-right: 20px;
  height: 40px;
  align-items: center;
  color: #f00;
}

.ninputs {
  height: 32px;
  padding: 4px 11px;
  color: rgba(0, 0, 0, 0.65);
  font-size: 0.875rem;
  line-height: 1.5;
  background-color: #fff;
  background-image: none;
  border: 1px solid #d9d9d9;
  border-radius: 4px;
  -webkit-transition: all 0.3s;
  transition: all 0.3s;
  width: 200px;
  margin-top: 5px;
}

.licter {
  overflow: hidden;
  margin-bottom: 12px;
  display: flex;
  align-items: center;

  label {
    float: left;
    font-size: 0.875rem;
    text-align: right;
    color: #333;
    line-height: 30px;
    margin-right: 20px;
  }

  .clearbtn {
    float: left;
  }

  .rmain {
    // padding-left: 20px;
    // margin-left: 20px;
    float: left;

    a {
      width: 68px;
      line-height: 36px;
      background: #b2c9e1;
      border-radius: 4px;
      display: inline-block;
      margin-right: 20px;
      font-size: 0.875rem;
      color: #fff;
      text-align: center;
      transition-duration: 500ms;

      &:hover {
        background: #1d8bfe;
      }
    }
  }
}
</style>